export const  message = {
  language:'语言',
  app_name:'Evebot-咖啡拉花机',
  next: '下一步',
  device_id: '设备号',
  device_id_placeholder:'请输入设备号',
  device_id_not_valid:'设备号不合法',
  device_id_not_exist:'设备号不存在',
  upload_phone:'从手机上传',
  group_id_not_exist:'图片组不存在',
  join_id_not_exist:'参数错误',
  image_edit:'图片编辑',
  image_not_exist:'图片不存在',
  image_upload_success:`我们已经收到你的图片，咖啡正在准备中。`,
  image_upload_error:'图片上传失败',
  image_code:'取图码',
  image_code2:'图片编号',
  confirm:`确认`,
  uploading:`上传中`,
  cancel:`取消`,
  finish:`完成`,
  another:`再来一个`,
  small_ticket:`小票`,
  small_ticket_placeholder:`请输入小票`,
  small_not_verify:`请输入数字和英文字母`,
  website_error:`网址错误，请从新检查。`,
  add_text:`添加文字`,
  add_text_first:`请先添加文字`,
  enter_text:`请输入文字`,
  prompt_box:`提示框`,
  gallery:'拉花图库',
  upload:'图片上传',
  token_error:'token验证失败',
  image_list:'图片列表',
  select_prompt:"您的图片将直接传到对应拉花机，服务器不会保存和收集任何个人信息",

  setting:'设置',
  watermark_switch:'水印开关',
  watermark_upload:'水印上传',
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/zh.js